export enum LinkApplication {
    default = 'default',
    mysosh = 'mySosh',
    omoi = 'omoi',
    orange = 'ecmOrange',
    sosh = 'ecmSosh',
}
